// 引入和配置 axios
import axios from "axios";
axios.defaults.withCredentials = false; //跨域访问需要发送cookie时使用
let instance = axios.create({
	timeout: 1000,
	headers: {
		"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
	},
	withCredentials: false, // 不携带cookie
})
// 添加响应拦截器
instance.interceptors.response.use(function(response) {
	// 对响应数据做点什么
	if (response.data.status == 200) {
		console.log("请求发送成功")
	}
	return response;
}, function(error) {
	// 对响应错误做点什么
	// alert('出错了')
	return Promise.reject(error);
});

export {
	instance
}



// WEBPACK FOOTER //
// ./src/api/index.js